import { gql } from "@apollo/client";

const GET_PAYMENT_METHODS = gql`
  query GetPaymentMethods {
    me {
      paymentMethods {
        id
        brand
        last4
        default
      }
    }
  }
`;

export default GET_PAYMENT_METHODS;
